module.exports = __webpack_public_path__ + "media/images/riders/small/BENOIT_COULANGES-8c3472845cf2042f0f535e8fc5b9a6b1.png";